import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ButtonToggle, Flex } from '@servicetitan/anvil2';
import { useDependencies } from '@servicetitan/react-ioc';

import { ChatStore } from '../../stores/chat.store';
import { MainStore } from '../../stores/main.store';
import { MessageType } from '../../models/message-type.model';

interface FeedbackOptionsProps {}

export const FeedbackOptions: FC<FeedbackOptionsProps> = observer(() => {
    const [chatStore, mainStore] = useDependencies<[ChatStore, MainStore]>(ChatStore, MainStore);
    const history = useHistory();

    const handleStartOver = () => {
        mainStore.resetSelected();
        history.push(`/${mainStore.selectedAppointment?.id}/topic-picker`);
    };

    const handleGiveFeedback = () => {
        chatStore.enqueueMessages([
            {
                isMine: true,
                type: MessageType.Text,
                text: 'Give feedback about answer',
                date: new Date(),
            },
            {
                isMine: false,
                type: MessageType.Text,
                showAvatar: true,
                text: 'I apologize for the incorrect information. Could you please specify what was incorrect or provide more details about the issue so I can correct it?',
            },
            {
                isMine: false,
                type: MessageType.FeedbackDetails,
                date: new Date(),
            },
        ]);
    };

    const handleProvideMoreDetails = () => {
        chatStore.enqueueMessages([
            {
                isMine: true,
                type: MessageType.Text,
                text: 'Provide more details',
                date: new Date(),
            },
            {
                isMine: false,
                type: MessageType.Text,
                showAvatar: true,
                text: `Certainly! Could you please provide a bit more detail about your question so I can assist you more effectively?
You might rephrase the question, include additional information, or describe the context in greater detail.`,
            },
        ]);
    };

    return (
        <Flex className="w-100" wrap="wrap" gap="2">
            <ButtonToggle className="m-b-1" onClick={handleProvideMoreDetails}>
                Provide more details
            </ButtonToggle>
            <ButtonToggle className="m-b-1" onClick={handleStartOver}>
                Start over
            </ButtonToggle>
            <ButtonToggle className="m-b-1" onClick={handleGiveFeedback}>
                Give feedback about answer
            </ButtonToggle>
        </Flex>
    );
});
